/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { LastTransactionFailure } from './LastTransactionFailure';
import { PaymentOptions } from './PaymentOptions';
const PaymentRequiredParser = /* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('payment-required')],
    ['paymentOptions', PaymentOptions, 'payment_options'],
    [
        'lastTransactionFailure',
        /* #__PURE__ */ parsers.maybeNull(LastTransactionFailure),
        'last_transaction_failure',
    ],
]);
export class PaymentRequired extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PaymentRequiredParser.decode(input).map(res => new PaymentRequired(res));
    }
    static unsafeDecode(input) {
        return PaymentRequired.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PaymentRequiredParser.encode(data);
    }
    static schema() {
        return PaymentRequiredParser.schema();
    }
}
